export function initVideoControls(videos, id = null, options = {}) {
  const PAUSE_ICON = '<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none"><path d="M10.625 0.875V9.625C10.625 9.85706 10.5328 10.0796 10.3687 10.2437C10.2046 10.4078 9.98206 10.5 9.75 10.5H7.5625C7.33044 10.5 7.10788 10.4078 6.94378 10.2437C6.77969 10.0796 6.6875 9.85706 6.6875 9.625V0.875C6.6875 0.642936 6.77969 0.420376 6.94378 0.256282C7.10788 0.0921872 7.33044 0 7.5625 0H9.75C9.98206 0 10.2046 0.0921872 10.3687 0.256282C10.5328 0.420376 10.625 0.642936 10.625 0.875ZM3.0625 0H0.875C0.642936 0 0.420376 0.0921872 0.256282 0.256282C0.0921872 0.420376 0 0.642936 0 0.875V9.625C0 9.85706 0.0921872 10.0796 0.256282 10.2437C0.420376 10.4078 0.642936 10.5 0.875 10.5H3.0625C3.29456 10.5 3.51712 10.4078 3.68122 10.2437C3.84531 10.0796 3.9375 9.85706 3.9375 9.625V0.875C3.9375 0.642936 3.84531 0.420376 3.68122 0.256282C3.51712 0.0921872 3.29456 0 3.0625 0Z" fill="white"/></svg>';
  const PLAY_ICON = '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12" fill="none"><path d="M9.625 5.68777C9.62536 5.83632 9.58727 5.98243 9.51444 6.1119C9.44161 6.24136 9.33652 6.34978 9.20938 6.4266L1.33 11.2468C1.19716 11.3281 1.04501 11.3725 0.889261 11.3754C0.733517 11.3783 0.579827 11.3395 0.444063 11.2632C0.309591 11.188 0.197573 11.0783 0.119527 10.9455C0.0414813 10.8127 0.000224688 10.6614 0 10.5074V0.868164C0.000224688 0.714101 0.0414813 0.562878 0.119527 0.430046C0.197573 0.297215 0.309591 0.187568 0.444063 0.112382C0.579827 0.0360104 0.733517 -0.00273412 0.889261 0.000150033C1.04501 0.00303418 1.19716 0.0474425 1.33 0.128789L9.20938 4.94894C9.33652 5.02577 9.44161 5.13418 9.51444 5.26365Q9.58727 5.39312 9.625 5.68777Z" fill="white"/></svg>';

  const player = options.player || null;

  const isPaused = (video) => (player ? player.paused() : video.paused);
  const playMedia = (video) => (player ? player.play() : video.play());
  const pauseMedia = (video) => (player ? player.pause() : video.pause());
  const getReadyState = (video) => (player ? player.readyState() : video.readyState);
  const addMediaListener = (video, event, handler) => {
    if (player) {
      player.on(event, handler);
    } else {
      video.addEventListener(event, handler);
    }
  };

  videos.forEach((video, index) => {
    if (video.closest('.video-wrapper-accessible')) return;

    if (!player && video.hasAttribute('controls') && video.hasAttribute('autoplay')) {
      video.removeAttribute('controls');
    }

    if (!video.id) {
      // eslint-disable-next-line
      video.id = `accessible-video-${id ?? index}`;
    }

    const computedStyle = window.getComputedStyle(video);
    const isAbsolute = computedStyle.position === 'absolute';
    const isHeroHome = video.closest('.hero-home');
    const isHero = video.classList.contains('hero__video-background')
      || video.id === 'hero-background-video'
      || video.closest('.hero__video-background-outer');
    const wrapper = document.createElement('div');
    wrapper.className = 'video-wrapper-accessible';

    let slideParent = null;

    if (isHero) {
      wrapper.classList.add('video-wrapper-accessible--hero');
      slideParent = video.closest('.hero__slide-outer') || video.closest('.swiper-slide');

      if (slideParent) {
        slideParent.classList.add('hero-slide-accessible-video');
      }
    } else if (isHeroHome) {
      wrapper.classList.add('video-wrapper-accessible--absolute');
      slideParent = isHeroHome;
    } else if (isAbsolute) {
      wrapper.classList.add('video-wrapper-accessible--absolute');
    }

    video.parentNode.insertBefore(wrapper, video);
    wrapper.appendChild(video);
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'video-pause-control';
    btn.setAttribute('aria-controls', video.id);

    const updateButtonState = () => {
      const iconContainer = btn.querySelector('.video-pause-control__icon');
      if (!iconContainer) return;

      if (isPaused(video)) {
        btn.setAttribute('aria-label', 'Play video');
        btn.setAttribute('aria-pressed', 'false');
        iconContainer.innerHTML = PLAY_ICON;
      } else {
        btn.setAttribute('aria-label', 'Pause video');
        btn.setAttribute('aria-pressed', 'true');
        iconContainer.innerHTML = PAUSE_ICON;
      }
    };

    const updateButtonVisibility = () => {
      let isVisible = getReadyState(video) >= 3;

      if (isHeroHome) {
        if (video.classList.contains('hero-home__media-default')) {
          if (video.classList.contains('hero-home__media-default--hide')) isVisible = false;
        } else if (video.classList.contains('hero-home__media')) {
          if (!video.classList.contains('hero-home__media--active')) isVisible = false;
        }
      }

      if (isVisible) {
        btn.style.opacity = '';
        btn.style.pointerEvents = '';
        btn.style.zIndex = '100';

        if (isHeroHome) {
          btn.setAttribute('tabindex', '-1');
        } else {
          btn.removeAttribute('tabindex');
        }

        if (btn.proxyBtn) btn.proxyBtn.removeAttribute('tabindex');
      } else {
        btn.style.opacity = '0';
        btn.style.pointerEvents = 'none';
        btn.style.zIndex = '-1';
        btn.setAttribute('tabindex', '-1');
        if (btn.proxyBtn) btn.proxyBtn.setAttribute('tabindex', '-1');
      }
    };

    btn.innerHTML = `<span class="video-pause-control__icon">${isPaused(video) ? PLAY_ICON : PAUSE_ICON}</span>`;
    updateButtonState();
    updateButtonVisibility();

    if (isHeroHome) {
      const observer = new MutationObserver(updateButtonVisibility);
      observer.observe(video, { attributes: true, attributeFilter: ['class', 'style'] });
    }

    if (isHeroHome) {
      const navIndex = video.dataset.heroHomeNavItem;
      let navLink = null;
      if (navIndex) {
        const navItem = isHeroHome.querySelector(`.hero-home__nav-item[data-hero-home-nav-item="${navIndex}"]`);
        if (navItem) navLink = navItem.querySelector('.hero-home__nav-content');
      }

      const parent = isHeroHome.parentNode;
      if (window.getComputedStyle(parent).position === 'static') {
        parent.style.position = 'relative';
      }
      parent.appendChild(btn);

      btn.style.position = 'absolute';
      btn.style.bottom = 'auto';

      const updatePosition = () => {
        const heroHeight = isHeroHome.offsetHeight;
        btn.style.top = `${heroHeight - 52}px`;
      };

      updatePosition();
      window.addEventListener('resize', updatePosition);

      if (navLink) {
        const proxyBtn = document.createElement('button');
        proxyBtn.type = 'button';
        proxyBtn.className = 'video-pause-proxy';
        proxyBtn.setAttribute('aria-hidden', 'true');
        // Make it invisible but focusable
        proxyBtn.style.position = 'absolute';
        proxyBtn.style.width = '1px';
        proxyBtn.style.height = '1px';
        proxyBtn.style.padding = '0';
        proxyBtn.style.margin = '-1px';
        proxyBtn.style.overflow = 'hidden';
        proxyBtn.style.clip = 'rect(0, 0, 0, 0)';
        proxyBtn.style.whiteSpace = 'nowrap';
        proxyBtn.style.border = '0';

        btn.proxyBtn = proxyBtn;
        navLink.parentNode.insertBefore(proxyBtn, navLink.nextSibling);

        const syncProxyTabindex = () => {
          if (btn.style.opacity === '0') {
            proxyBtn.setAttribute('tabindex', '-1');
          } else {
            proxyBtn.removeAttribute('tabindex');
          }
        };

        const observer = new MutationObserver(syncProxyTabindex);
        observer.observe(btn, { attributes: true, attributeFilter: ['style'] });
        syncProxyTabindex();

        proxyBtn.addEventListener('focus', () => {
          btn.focus();
        });

        btn.addEventListener('keydown', (e) => {
          if (e.key === 'Tab') {
            e.preventDefault();
            if (!e.shiftKey) {
              const focusableElements = Array.from(document.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'));
              const proxyIndex = focusableElements.indexOf(proxyBtn);

              let nextElement = null;
              for (let i = proxyIndex + 1; i < focusableElements.length; i++) {
                if (focusableElements[i] !== btn && !focusableElements[i].classList.contains('video-pause-control')) {
                  nextElement = focusableElements[i];
                  break;
                }
              }

              if (nextElement) {
                nextElement.focus();
              }
            } else {
              navLink.focus();
            }
          }
        });
      }
      btn.setAttribute('tabindex', '-1');
    } else if (isHero && slideParent) {
      slideParent.appendChild(btn);
    } else {
      wrapper.appendChild(btn);
    }

    const playPromise = playMedia(video);
    if (playPromise !== undefined && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {
        updateButtonState();
      });
    }

    addMediaListener(video, 'play', updateButtonState);
    addMediaListener(video, 'pause', updateButtonState);
    addMediaListener(video, 'canplay', updateButtonVisibility);
    addMediaListener(video, 'playing', updateButtonVisibility);
    addMediaListener(video, 'waiting', updateButtonVisibility);

    btn.addEventListener('click', () => {
      if (isPaused(video)) {
        playMedia(video);
      } else {
        pauseMedia(video);
      }
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    const videos = document.querySelectorAll('video[autoplay]');
    initVideoControls(videos);
  });
} else {
  const videos = document.querySelectorAll('video[autoplay]');
  initVideoControls(videos);
}
